const SharedString ={
    JWT_TOKEN_FIELD: "jwtToken",
    LOGIN_FIELD: "login",
    USERID_FIELD: "userMail",
    BASKET_FIELD: "basketItem",
    ROLE_ADMIN: "ROLE_ADMIN",
    ACTIVE_USER: "activeUser",
}
export default SharedString;